import { Box, Stack, Typography } from '@mui/material'
import { GOAL_ICON, GOALS, type Goal } from './goalViews'
import { styles } from './GoalsSidebar.styles'

interface Props {
  activeGoal: Goal
  onSelect: (goal: Goal) => void
}

export const GoalsSidebar = ({ activeGoal, onSelect }: Props): JSX.Element => (
  <Box sx={styles.container} data-testid='p2pGoalsSidebar'>
    <Box sx={styles.header}>
      <Typography variant='h5' sx={styles.headerTitle}>Goals</Typography>
    </Box>
    <Box sx={styles.hint}>
      <Typography variant='caption' sx={{ color: 'text.secondary' }}>Select a goal to explore the corresponding data.</Typography>
    </Box>
    <Stack>
      {GOALS.map(goal => (
        <Box
          key={goal}
          onClick={() => { onSelect(goal) }}
          data-testid={`p2pGoalView-${goal}`}
          sx={styles.item(activeGoal === goal)}
        >
          {GOAL_ICON[goal]}
          <Typography variant='body1' sx={{ fontWeight: 'inherit' }}>{goal}</Typography>
        </Box>
      ))}
    </Stack>
  </Box>
)
